import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["google", "trustpilot", "jameda", "kununu", "facebook", "tripadvisor", "ekomi", "proven_expert"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const selected = Array.from(this.element.querySelectorAll("input[type='checkbox']:checked"))
      .map(cb => cb.value)

    this.googleTarget.classList.toggle("hidden", !selected.includes("google"))
    this.trustpilotTarget.classList.toggle("hidden", !selected.includes("trustpilot"))
    this.jamedaTarget.classList.toggle("hidden", !selected.includes("jameda"))
    this.kununuTarget.classList.toggle("hidden", !selected.includes("kununu"))
    this.facebookTarget.classList.toggle("hidden", !selected.includes("facebook"))
    this.tripadvisorTarget.classList.toggle("hidden", !selected.includes("tripadvisor"))
    this.ekomiTarget.classList.toggle("hidden", !selected.includes("ekomi"))
    this.proven_expertTarget.classList.toggle("hidden", !selected.includes("proven_expert"))
  }
}
